import React, { useEffect } from "react";
import Contracts from "../../../Components/PaymentLedger/Contracts/Contracts";
import { useDispatch, useSelector } from "react-redux";
import {
  walletAccount,
  walletContract,
} from "../../../Redux/Slices/paymentSlice";

const Page_Contract = () => {
  const dispatch = useDispatch();
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive
  );
  console.debug("wallet", wallet);

  useEffect(() => {
    if (wallet?.id) {
      dispatch(walletContract({ id: wallet?.id }));
    } else {
      window.history.back();
    }
  }, [dispatch, wallet?.id]);
  return <Contracts />;
};

export default Page_Contract;
